import React, { useState } from 'react';
import styled from 'styled-components';
import AddActivity from '../AddActivity';
import CreateObjective from '../CreateObjective';
import ManageCategories from '../ManageCategories/';
import { useDispatch, useSelector } from 'react-redux';

const HeaderNavMain = styled.div`
               	ul{
					display:inline-block;
					
					li{
						display:block;
						float:left;
						color: #818E94;
						padding: 60px 17px 0px 17px; 
						font-size:12px;
						
						&:nth-child(2), &:nth-child(3), &:nth-child(4),&:nth-child(5){
							color:#000;   
							background-image:url('/assets/images/add_button.png');
							background-size:50px 50px;
							background-repeat:no-repeat;
							background-position:top center;

							&:hover{
								cursor:pointer;
							}
						}
					}
               }

               .modal-dialog {
                max-width: 900px;
            }
`;

function HeaderNav() {
	const [show, setShow] = useState(false);
	const [showPriority, setShowPriority] = useState(false);
	const [showObjective, setShowObjective] = useState(false);
	const [showCategoriesModal, setShowCategoriesModal] = useState(false);

	const currentUser = useSelector(state => state.currentUser);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const handlePriorityClose = () => setShowPriority(false);
	const handlePriorityShow = () => setShowPriority(true);

	const handleObjectiveClose = () => setShowObjective(false);
	const handleObjectiveShow = () => setShowObjective(true);

	const handleCategoriesModal = () => setShowCategoriesModal(true);
	const handleCategoriesClose = () => setShowCategoriesModal(false);

	return (
		<div>
			<HeaderNavMain>
				<ul>
					<li></li>
					{currentUser.role === 'admin' ?
						<li onClick={handleObjectiveShow}>Business Priorities</li>
						: ''}
					<li onClick={handlePriorityShow}>Department Deliverables</li>
					<li onClick={handleShow}>Tasks and Activities</li>
					<li onClick={handleCategoriesModal}>Manage Departments</li>

				</ul>
			</HeaderNavMain>
			<AddActivity show={show} onHide={handleClose} />
			<AddActivity show={showPriority} onHide={handlePriorityClose} deliverable={true} />
			<CreateObjective show={showObjective} onHide={handleObjectiveClose} />
			<ManageCategories show={showCategoriesModal} onHide={handleCategoriesClose} />
		</div>
	);
}

export default HeaderNav;